import React from 'react';
import IconComponent from '../IconComponent';

type Props = React.SVGProps<SVGSVGElement>;

export default function ChevronLeftIcon({
  height = 24,
  width = 24,
  color = 'inherit',
  ...props
}: Props) {
  return (
    <IconComponent
      height={height}
      width={width}
      color={color}
      path="M11.1529 19.6743L4.21911 12.5431C3.92696 12.2429 3.92696 11.7579 4.21911 11.4569L11.1529 4.32572C11.5746 3.89143 12.2608 3.89143 12.6833 4.32572C13.105 4.76002 13.105 5.46488 12.6833 5.89917L6.75185 12.0004L12.6833 18.1C13.105 18.5351 13.105 19.24 12.6833 19.6743C12.2608 20.1086 11.5746 20.1086 11.1529 19.6743"
      {...props}
    />
  );
}
